import React from "react";

export default function Kebidanan() {
  return (
    <table className="table-auto w-full lg:w-5/6  text-center my-3 mb-12">
      <thead>
        <tr className=" border">
          <th className="border border-slate-300 p-2">Hari</th>
          <th className="border border-slate-300 p-2">Pukul</th>
          <th className="border border-slate-300 p-2">Nama</th>
        </tr>
      </thead>
      <tbody>
        <tr className="">
          <td className="border border-slate-300 p-1">Senin - Minggu</td>
          <td className="border border-slate-300 p-1">Melayani 24 jam</td>
          <td className="border border-slate-300 p-1">
            Elizabeth, Amd.Keb.
            <br></br>Dyna, Amd.Keb.
            <br></br>Tia, Amd.Keb.
          </td>
        </tr>
      </tbody>
    </table>
  );
}
